/**
 * Lavafields – Inclus dans la boîte
 *
 * Ouvre le drawer d'un composant au clic sur sa carte, en s'appuyant
 * uniquement sur l'API publique du thème : Woolman.ModalsAndDrawers
 * (défini dans assets/global.js, non modifié ici).
 *
 * Les drawers sont déplacés dans <body> au montage : un drawer en
 * position: fixed doit être enfant du body pour couvrir toute la page
 * (sinon il est piégé par un ancêtre transformé — .gridy-slider, etc.).
 * Même approche que assets/component-pickup-availability.js.
 */
if (!customElements.get('lavafields-included-in-the-box')) {
  class LavafieldsIncludedInTheBox extends HTMLElement {
    connectedCallback() {
      this.onTriggerClick = this.onTriggerClick.bind(this);
      this.onPanelControlClick = this.onPanelControlClick.bind(this);

      this.relocateDrawers();
      this.addEventListener('click', this.onTriggerClick);
      this.bindPanelControls();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onTriggerClick);
      this.panelControls?.forEach((el) => {
        el.removeEventListener('click', this.onPanelControlClick);
      });
      this.relocatedDrawers?.forEach((el) => el.remove());
      this.relocatedDrawers = [];
      this.panelControls = [];
    }

    get modalsApi() {
      return window.Woolman && window.Woolman.ModalsAndDrawers;
    }

    relocateDrawers() {
      this.relocatedDrawers = Array.from(this.querySelectorAll('[data-drawer]'));
      this.relocatedDrawers.forEach((drawer) => {
        const existing = drawer.id && document.getElementById(drawer.id);
        if (existing && existing !== drawer) existing.remove();
        document.body.appendChild(drawer);
      });
    }

    onTriggerClick(event) {
      const trigger = event.target.closest('a[href^="#drawer-"]');
      if (!trigger || !this.contains(trigger)) return;

      event.preventDefault();

      const api = this.modalsApi;
      if (!api || typeof api.showModalOrDrawer !== 'function') return;

      const targetId = trigger.getAttribute('href').slice(1);
      api.showModalOrDrawer(targetId);
    }

    bindPanelControls() {
      this.panelControls = [];
      this.relocatedDrawers.forEach((drawer) => {
        drawer.querySelectorAll('[data-close], [data-overlay]').forEach((el) => {
          el.addEventListener('click', this.onPanelControlClick);
          this.panelControls.push(el);
        });
      });
    }

    onPanelControlClick(event) {
      const api = this.modalsApi;
      if (!api || typeof api.closeModalOrDrawerOrDrawerFromEvent !== 'function') return;

      api.closeModalOrDrawerOrDrawerFromEvent(event);
    }
  }

  customElements.define('lavafields-included-in-the-box', LavafieldsIncludedInTheBox);
}
